module.exports = __webpack_public_path__ + "static/img/ninja-can-27.f45fa6e4.png";